import Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

const isInternetExplorer = browser.satisfies({
  windows: {
    'ie': '>=10'
  }
});

if (isInternetExplorer) {
  console.log('Why would you use IE 11? :(');
}

export const HotspotTypes = {
  Generic: 0,
  LongFormText: 1,
  VideoEmbed: 2,
  MapEmbed: 3,
  CommentForm: 4,
  Poster: 5,
  Gallery: 6,
  CustomForm: 7,
};

const EQUIRECT_ROOT = 'equirects/';
const createTheme = (equirectFileName, imageWidth) => ({ src: EQUIRECT_ROOT + equirectFileName, imageWidth });

/**
 * Format: { <id> : Theme}
 * [ Theme.src ]: String - '/web-path/to/image.jpg'
 * [ Theme.imageWidth ]: Number - Width of the image 
 */
export const Themes = {
  Angra: createTheme('angra.jpg', 4000),
  Room: createTheme('room-test.jpg', 4096),
  Room2: createTheme('updated_room_test.jpg', 4096),
  Strathkelvin: createTheme('strathkelvin_4k.jpg', 4096),
};

export const CustomFormPartTypes = {
  submitTextOverride: -1,
  para: 0,
  input: 1,
  textarea: 2,
  starRating: 3,
  radioChoice: 4,
}

export const CustomFormParts = {
  para: (content) => ({ partType: CustomFormPartTypes.para, content }),
  input: (name, type, label, required = false) => ({ partType: CustomFormPartTypes.input, name, type, label, required }),
  textarea: (name, label, required = false) => ({ partType: CustomFormPartTypes.textarea, name, label, required }),
  starRating: (name, label, required = false) => ({ partType: CustomFormPartTypes.starRating, name, label, required }),
  radioChoice: (name, label, options = [], required = false) => ({ partType: CustomFormPartTypes.radioChoice, name, label, options, required }),
  submitTextOverride: (text) => ({ partType: CustomFormPartTypes.submitTextOverride, text }),
};

export const posterExtraButton = (text, link) => ({ text, link });